import Search from '../../MainContent/Search/Search';
import Marquee from '../../Marquee/Marquee'
const DeputyMinisters = () => {
    return (
        <div className="container">
            <Search />
            <h4 class="pb-4 pt-4 mb-4  border-bottom">
                Муовини Вазир
            </h4>
            <div class="card mb-3" style={{ "max-width": "540px;" }}>
                <div class="row g-1">

                    <div class="col-md-9 pt-4">
                        <div class="card-body ">
                            <h6 class="card-title text-center"> ҶӮРАЗОДА ҶАМШЕД ҲАБИБУЛЛО</h6>
                            <h6 class="card-title text-center">МУОВИНИ ЯКУМИ ВАЗИРИ МАОРИФ ВА ИЛМИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                            <p class="card-text" style={{ "textAlign": "justify" }}>
                                15 июни соли 1971 дар Ҷумҳурии Тоҷикистон таваллуд шудааст, тоҷик, маълумоташ олӣ, доктори илмҳои таърих.
                            </p>
                            <h6 class="card-title text-center" >
                                ФАЪОЛИЯТИ МЕҲНАТӢ:</h6>
                            <p class="card-text" style={{ "textAlign": "justify" }}>
                                <small class="text-muted" >

                                    <strong>
                                        Солҳои 1989-1993
                                    </strong>
                                    донишҷӯйи Донишкадаи давлатии омӯзгории Ленинобод ба номи С.М.Киров (ҳоло Донишгоҳи давлатии Хуҷанд ба номи академик Бобоҷон Ғафуров);<br />
                                    <strong>
                                        Солҳои 1993-1995-
                                    </strong>
                                    ассистенти кафедраи таърих ва этнографияи халқи тоҷики ДДХ ба номи академик Б. Ғафуров;<br />
                                    <strong>
                                        Солҳои 1997-2000-
                                    </strong>
                                    ассистенти кафедраи фанҳои ҷамъиятии Донишгоҳи давлатии ҳуқуқ, бизнес ва сиёсати Тоҷикистон;<br />


                                    <strong>
                                        Солҳои 2000-2003-
                                    </strong>
                                    мудири шуъбаи корҳои иҷтимоӣ-маданӣ, алоқа бо ташкилотҳои ҷамъиятию сиёсӣ ва робитаҳои байналмилалии ҳукумати шаҳри Хуҷанд;<br />


                                    <strong>
                                        Солҳои 2003-2005
                                    </strong>
                                    муовини мудири шуъбаи масоили иҷтимоӣ-фарҳангӣ, робита бо созмонҳои ҷамъиятию сиёсӣ ва муносибатҳои байнимиллии ҳукумати вилояти Суғд;<br />

                                    <strong>
                                        Солҳои 2005-2006-
                                    </strong>
                                    декани факултети сиёсатшиносӣ ва муносибатҳои байналхалқии Донишгоҳи давлатии ҳуқуқ, бизнес ва сиёсати Тоҷикистон;  <br />

                                    <strong>
                                        Солҳои 2006-2009
                                    </strong>
                                    ноиби ректор оид ба тарбияи Донишгоҳи давлатии ҳуқуқ, бизнес ва сиёсати Тоҷикистон;<br />

                                    <strong>
                                        Солҳои 2009-2012-
                                    </strong>
                                    декани факултети сиёсатшиносӣ ва муносибатҳои байналхалқии Донишгоҳи давлатии ҳуқуқ, бизнес ва сиёсати Тоҷикистон;    <br />

                                    <strong>
                                        Солҳои 2012-2017
                                    </strong>
                                    ректори Донишгоҳи давлатии ҳуқуқ, бизнес ва сиёсати Тоҷикистон;    <br />

                                    <strong>
                                        Солҳои 2017-2022-
                                    </strong>
                                    ректори Донишгоҳи давлатии Хуҷанд ба номи академик Б. Ғафуров;<br />
                                    Аз 21 феврали соли 2022 то ҳол-муовини якуми вазири маориф ва илми Ҷумҳурии Тоҷикистон.
                                    Оиладор, соҳиби 2 фарзанд.</small>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-3 p-4 ">
                        <img
                            src="https://maorif.tj/storage/posts/February2022/h8RtmTOWExupS434X1mt.jpg"
                            alt="Trendy Pants and Shoes"
                            class="pt-4 img-fluid rounded-start"
                        />
                    </div>

                    <div class="col-md-3 p-4 ">
                        <img
                            src="https://maorif.tj/storage/posts/February2022/hDQyHoaBbstcO9uUkkkk.JPG"
                            alt="Trendy Pants and Shoes"
                            class="pt-4 img-fluid rounded-start"
                        />
                    </div>
                    <div class="col-md-9 pt-4">
                        <div class="card-body ">

                            <h6 class="card-title text-center"> АБДУЛХОЛИҚЗОДА ЛУТФИЯ АБДУЛХОЛИҚ</h6>
                            <h6 class="card-title text-center">МУОВИНИ ВАЗИРИ МАОРИФ ВА ИЛМИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                            <p class="card-text" style={{ "textAlign": "justify" }}>
                                5 декабри соли 1971 дар Ҷумҳурии Тоҷикистон таваллуд шудааст, тоҷик, маълумоташ олӣ, доктори илмҳои педагогӣ.
                            </p>
                            <h6 class="card-title text-center" >
                                ФАЪОЛИЯТИ МЕҲНАТӢ:</h6>
                            <p class="card-text" style={{ "textAlign": "justify" }}>
                                <small class="text-muted" >

                                    <strong>
                                        Солҳои 1988-1993-
                                    </strong>
                                    донишҷӯйи Донишгоҳи давлатии омӯзгории Тоҷикистон ба номи Қ.Ҷӯраев;<br />
                                    <strong>
                                        Солҳои 1993-2002-
                                    </strong>
                                    -муаллими забони русӣ дар Коллеҷи муҳандисӣ-омӯзгории шаҳри Душанбе;<br />
                                    <strong>
                                        Солҳои 2002-2009-
                                    </strong>
                                    муаллими калони кафедраи забонҳо ва раиси Шӯрои кураторони Донишкадаи иқтисодии Тоҷикистон;<br />
                                    <strong>
                                        Солҳои 2010-2012-
                                    </strong>
                                    муовини ректор оид ба тарбия ва алоқа бо ҷомеаи Донишкадаи иқтисодии Тоҷикистон;<br />
                                    <strong>
                                        Солҳои 2015-2019-
                                    </strong>
                                    ректори Донишкадаи идоракунии давлатии назди Президенти Ҷумҳурии Тоҷикистон;<br />

                                    <strong>
                                        Солҳои 2019-2020-
                                    </strong>
                                    сардори раёсати илму маърифати Дастгоҳи иҷроияи Президенти Ҷумҳурии Тоҷикистон; <br />

                                    <strong>
                                        Солҳои 2020-2022-
                                    </strong>
                                    вакили Маҷлиси намояндагони Маҷлиси Олии Ҷумҳурии Тоҷикистон;<br />

                                    Аз 21 феврали соли 2022 то ҳоло-муовини вазири маориф ва илми Ҷумҳурии Тоҷикистон.
                                    Оиладор, соҳиби 3 фарзанд.</small>
                            </p>
                        </div>
                    </div>

                    <div class="col-md-3 p-4 ">
                        <img
                            src="https://maorif.tj/storage/posts/February2022/6RFU14Eue236H17ocalJ.jpg"
                            alt="Trendy Pants and Shoes"
                            class="pt-4 img-fluid rounded-start"
                        />
                    </div>
                    <div class="col-md-9 pt-4">
                        <div class="card-body ">

                            <h6 class="card-title text-center"> ХАЙРЗОДА ШУКРУЛЛО ҚУРБОНАЛӢ</h6>
                            <h6 class="card-title text-center">МУОВИНИ ВАЗИРИ МАОРИФ ВА ИЛМИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                            <p class="card-text" style={{ "textAlign": "justify" }}>
                                27 январи соли 1983 дар Ҷумҳурии Тоҷикистон таваллуд шудааст, тоҷик, маълумоташ олӣ, доктори илмҳои иқтисодӣ.
                            </p>
                            <h6 class="card-title text-center" >
                                ФАЪОЛИЯТИ МЕҲНАТӢ:</h6>
                            <p class="card-text" style={{ "textAlign": "justify" }}>
                                <small class="text-muted" >

                                    <strong>
                                        Солҳои 2000-2005-
                                    </strong>
                                    донишҷӯйи Донишкадаи андоз ва ҳуқуқ;<br />
                                    <strong>
                                        Солҳои 2006-2010-
                                    </strong>
                                    ассистенти кафедраи фаъолияти бонкии Донишкадаи иқтисодии Тоҷикистон;<br />
                                    <strong>
                                        Солҳои 2010-2012-
                                    </strong>
                                    муаллими калони кафедраи фаъолияти бонкии Донишкадаи иқтисодии Тоҷикистон;<br />
                                    <strong>
                                        Солҳои 2012-2014
                                    </strong>
                                    мудири  кафедраи фаъолияти бонкии факултети молия ва қарзи  Донишкадаи молия  ва иқтисоди Тоҷикистон;<br />
                                    <strong>
                                        Солҳои 2014-2015-
                                    </strong>
                                    декани  факултети молия ва қарзи Донишкадаи молия ва иқтисоди  Тоҷикистон;<br />

                                    <strong>
                                        Солҳои 2015-2017-
                                    </strong>
                                    смуовини ректор оид ба таълими Донишкадаи молия ва иқтисоди  Тоҷикистон; <br />

                                    <strong>
                                        Соли 2018 (01.03)-
                                    </strong>
                                    ректори Донишкадаи молия ва иқтисоди  Тоҷикистон;<br />
                                    <strong>
                                        Солҳои 2018-2022
                                    </strong>
                                    ректори Донишгохи давлатии молия ва иқтисоди  Тоҷикистон;<br />

                                    Аз 21 феврали соли 2022 то ҳол-муовини вазири маориф ва илми Ҷумҳурии Тоҷикистон.
                                    Оиладор, соҳиби 5 фарзанд.</small>
                            </p>
                        </div>
                    </div>

                    <div class="col-md-3 p-4 ">
                        <img
                            src="https://maorif.tj/storage/posts/April2022/NVBd8kcZpIvtyxgktSvJ.jpeg"
                            alt="Trendy Pants and Shoes"
                            class="pt-4 img-fluid rounded-start"
                        />
                    </div>
                    <div class="col-md-9 pt-4">
                        <div class="card-body ">

                            <h6 class="card-title text-center"> АБДУЛЗОДА ЗИЁДУЛЛО НАЗАР</h6>
                            <h6 class="card-title text-center">МУОВИНИ ВАЗИРИ МАОРИФ ВА ИЛМИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                            <p class="card-text" style={{ "textAlign": "justify" }}>
                                2 ноябри соли 1971 дар Ҷумҳурии Тоҷикистон таваллуд шудааст, тоҷик, маълумоташ олӣ.
                            </p>
                            <h6 class="card-title text-center" >
                                ФАЪОЛИЯТИ МЕҲНАТӢ:</h6>
                            <p class="card-text" style={{ "textAlign": "justify" }}>
                                <small class="text-muted" >

                                    <strong>
                                        Солҳои 1989-1990-
                                    </strong>
                                    сарважатии мактаби миёнаи умумии №48-и ноҳияи Шоҳмансури шаҳри Душанбе;<br />
                                    <strong>
                                        Солҳои 1990-1991-
                                    </strong>
                                    -челонгари ширкати “Дизел”-и шаҳри Душанбе;<br />
                                    <strong>
                                        Солҳои 1991-1994-
                                    </strong>
                                    корманди ширкати “Силсила”-и шаҳри Душанбе;<br />
                                    <strong>
                                        Солҳои 1994-1995-
                                    </strong>
                                    муовини директори муассисаи таҳсилоти миёнаи умумии №2-и ноҳияи Шоҳмансури шаҳри Душанбе;<br />
                                    <strong>
                                        Солҳои 1995-2010-
                                    </strong>
                                    директори муассисаи таҳсилоти миёнаи умумии №2-и ноҳияи Шоҳмансури шаҳри Душанбе;<br />

                                    <strong>
                                        Солҳои 2010-2014-
                                    </strong>
                                    директори гимназияи №2 барои хонандагони болаёқати шаҳри Душанбе; <br />

                                    <strong>
                                        Соли 2014-2017-
                                    </strong>
                                    директори мактаб-интернати №1 барои кӯдакони ятими шаҳри Душанбе;<br />
                                    <strong>
                                        Солҳои 2017-2021-
                                    </strong>
                                    директори муассисаи таҳсилоти миёнаи умумии №35-и ноњияи Шоҳмансури шаҳри Душанбе;<br />
                                    <strong>
                                        Солҳои 2021-2022-
                                    </strong>
                                    директори литсейи №1-и шаҳри Душанбе;<br />

                                    Аз 11 апрели соли 2022 то ҳол-муовини вазири маориф ва илми Ҷумҳурии Тоҷикистон;
                                    Оиладор, соҳиби 4 фарзанд.</small>
                            </p>
                        </div>
                    </div>
                    <Marquee />
                </div>
            </div >
        </div >
    )
}

export default DeputyMinisters;